import React, {useEffect, useRef, useState} from "react";
import {Button, FlexContainer, Img, Input, InputWrapper, LabelText, Td, Text} from "../../../../design";
import {Container} from "react-awesome-styled-grid";
import UserIcon from "../../../../assets/imgs/suche.svg";
import {Controller, useForm} from "react-hook-form";
import {ErrorMessage} from "@hookform/error-message";
import {BiTrash} from "react-icons/bi";
import {Transition} from 'react-transition-group';
import {EMAIL} from "../../../../appconstants";

type Props = {
  emailRecipients: Array,
  add: Function,
  remove: Function,
  formShow: Boolean
}

const SubscribedEmail = (props: Props) => {

  const {
    control,
    handleSubmit,
    errors,
    reset,
  } = useForm();

  const duration = 200;

  const defaultStyle = {
    transition: `opacity ${duration}ms linear`,
    opacity: 0,
    display: 'none',
  };

  const transitionStyles = {
    entering: { opacity: 0.25, display: 'block' },
    entered: { opacity: 1, display: 'block' },
    exiting: { opacity: 0, display: 'block' },
    exited: { opacity: 0, display: 'none' },
  };

  const emailInputRef = useRef(null);

  const {emailRecipients, add, remove, formShow } = props;

  const [subscribedEmailFormShow, setSubscribedEmailFormShow] = useState(formShow || false);

  useEffect(() => {
    const subscribedEmailDoc = document.getElementById("subscribed-email");
    if(subscribedEmailDoc) {
        subscribedEmailDoc.style.display = "none";
        subscribedEmailDoc.style.opacity = "0";
        if(subscribedEmailFormShow) {
          reset({ email:''});
          subscribedEmailDoc.style.display = "block";
          subscribedEmailDoc.style.opacity = "1";
          emailInputRef.current && emailInputRef.current.focus();
          // emailInputRef.target.reset();
          reset({
            email:'',
          });
      }
    }
  },[subscribedEmailFormShow]);

  useEffect(() => {
    setSubscribedEmailFormShow(formShow);
  }, [formShow]);

  return (
    <>
      <div className="px-4">
        <LabelText
          marginTop="30px"
          marginBottom="10px"
        >
          Subscribed Email
        </LabelText>
      </div>
      <hr className="my-2"/>
      <FlexContainer paddingLeft="1.5rem" display="block" marginTop="1rem">
        <table>
          <tbody>
          {
            emailRecipients && emailRecipients.length > 0 ?
              emailRecipients.map( (value, index) => (
                <tr key={index} style={{verticalAlign: "middle"}}>
                  <Td className="border-0" color="#0d0d0d" fontWeight="600" paddingRight=".7rem">
                    <Text color="#0d0d0d" fontWeight="600" marginBottom=".5rem">{value}</Text>
                  </Td>
                  <Td className="border-0" color="#6b6c6f"  fontWeight="600">
                    <a style={{cursor: "pointer", fontSize: '20px'}}  onClick={() => remove(value)}>
                      <BiTrash/>
                    </a>
                  </Td>
                </tr>
              ))
              : <tr><td colSpan={2}><p className="text-muted">No Data</p></td></tr>
          }
          </tbody>
        </table>
        <Button style={{transition: 'opacity 1.15s linear'}} hidden={subscribedEmailFormShow} type="secondary" borderRadius="50px" border="1px solid #40a9ff !important" className="px-3 py-2 mt-3" onClick={() => setSubscribedEmailFormShow(true)} >+ Add an email</Button>

        <Transition
          in={subscribedEmailFormShow}
          timeout={duration}
        >
          {(stateTransition) => (
          <form
            style={{
              ...defaultStyle,
              ...transitionStyles[stateTransition],
            }}
            onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(add)(e);
          }}>
            <Container className="my-2 px-0" id="subscribed-email" style={{display: "none",opacity: 0, transition: 'opacity 0.15s linear'}}>
              <div>
                <InputWrapper marginTop="8px" paddingLeft='5px'  width='290px'>
                  <Img verticalAlign='middle' src={UserIcon} />
                  <Controller
                    color={errors.email ? "red" : "inherit"}
                    border="0px !important"
                    marginBottom="0px"
                    marginTop="0px"
                    marginLeft="5px"
                    paddingRight="0"
                    width='90%'
                    control={control}
                    name="email"
                    placeholder="Please enter email address"
                    rules={{
                      required: 'Email is required',
                      pattern: {
                        value: EMAIL.PAYMENTPAGE_EMAIL_REGEX,
                        message: EMAIL.DEFAULT_ERROR_MESSAGE,
                      },
                    }}
                    as={<Input name="email" ref={emailInputRef}/>}
                  />
                </InputWrapper>
                <ErrorMessage
                  errors={errors}
                  name="email"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </div>
              <div className="my-2">
                <button style={{borderRadius:"50px"}} type="button" className="btn btn-outline-primary btn-sm mr-2 px-3" onClick={() => setSubscribedEmailFormShow(false)}>Cancel</button>
                <button style={{borderRadius:"50px"}} type="submit" className="btn btn-primary btn-sm px-3">Add</button>
              </div>
            </Container>
          </form>
          )}
        </Transition>
      </FlexContainer>
    </>
  )
};

export default SubscribedEmail;
